<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-card class="px-3">
      <v-row>
        <v-col cols="12">
          <h3>Marker Details</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model.trim="item.lat"
            class="mr-2"
            label="Lat"
            required
          ></v-text-field>
          <v-text-field
            v-model.trim="item.lng"
            class="mr-2"
            label="Lng"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-alert
            v-if="formErrors.length > 0"
            type="error"
          >
            <v-list
              color="error"
            >
              <v-list-item
                v-for="(error, i) in formErrors"
                :key="`error-${i}`"
              >
                {{ error }}
              </v-list-item>
            </v-list>
          </v-alert>
        </v-col>
        <v-col cols="12">
          <v-btn @click="doCreateHeatTower(item)">
            Add Heat Tower
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay
        :value="overlayDisplay"
        :absolute="overlayAbsolute"
      >
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-container>
</template>

<script>
  // Utilities
  import { mapActions } from 'vuex'
  import { NotUnique } from '@/errors/bucketErrors'

  export default {
    name: 'PowHeatTowerDetails',

    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          lat: undefined,
          lng: undefined,
        }),
      },
    },
    data: function () {
      return {
        dialogNew: false,
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
      }
    },

    computed: {
    },
    async created () {
    },
    methods: {
      ...mapActions(['getCloudTowerConfigs', 'createHeatTower', 'createCloudTowerConfig', 'deleteCloudTowerConfig', 'createCloudTowerConfigMember', 'deleteCloudTowerConfigMember', 'getCloudTowerConfigMembers']),
      async doCreateHeatTower () {
        try {
          this.overlayDisplay = true
          const newHeatTower = await this.createHeatTower(this.item)
          this.$emit('itemCreated', { ...newHeatTower })
          this.resetForm()
        } catch (e) {
          if (e instanceof NotUnique) {
            this.formErrors = e.problems
            console.log(e.display_text)
            console.log(e)
          } else {
            this.formErrors = e.problems
            console.log('we encountered an error creating the heat tower', e)
            this.overlayDisplay = true
          }
        }
      },
      resetForm () {
        this.overlayDisplay = false
        this.formErrors = []
      },
    },

  }
</script>

<style>
</style>
